const inherit = require('inherit');
const Emitter = require('Emitter');
const features = require('Cloud/Application/Features');

module.exports = inherit(Emitter, {
    constructor: function CloudApi() {
        CloudApi.parent.call(this);

        this.features = features;

        this.ready = () => Promise.resolve();
        this.___ready = () => Promise.resolve();
        this.load = () => Promise.resolve();
    },
});
